export const MFDHeaderElements = [
  { label: "Código", value: "nroComprobante", align: "inherit" },
  { label: "Nomenclatura", value: "descripcion", align: "inherit" },
];
